module.exports = __webpack_public_path__ + "media/images/game_icon/zh-tw/AB1053-6e95ddd02f8257476b511d9feb425567.png";